import React from "react";
import PropTypes from "prop-types";

import { Column, Field, Control, Input } from "rbx";

import { ProductSelectAsync } from "../inputs";

const NewOrderOrderDetailForm = ({
  inputs,
  editing,
  onChange,
  ProductCatSale
}) => (
  <React.Fragment>
    <Column.Group>
      <Column size={5}>
        <Field>
          <Control>
            <ProductSelectAsync
              disabled={!editing}
              icon="globe"
              label=""
              name="ProductRecIdRef"
              value={inputs.ProductRecIdRef}
              where={{ ProductCatgRecIdRef: ProductCatSale.RecId }}
              onChange={onChange}
            />
          </Control>
        </Field>
      </Column>
      <Column size={6}>
        <Field>
          <Control>
            <Input
              disabled={!editing}
              name="Description"
              style={{ marginTop: 5 }}
              type="text"
              value={inputs.Description}
              onChange={onChange}
            />
          </Control>
        </Field>
      </Column>
      <Column size={1}>
        <Field>
          <Control>
            <Input
              autocomplete="new"
              defaultValue="1"
              disabled={!editing}
              name="Quantity"
              style={{ marginTop: 5 }}
              type="number"
              value={inputs.Quantity}
              onChange={onChange}
            />
          </Control>
        </Field>
      </Column>
    </Column.Group>
  </React.Fragment>
);

NewOrderOrderDetailForm.propTypes = {
  inputs: PropTypes.object,
  onChange: PropTypes.func,
  editing: PropTypes.bool,
  ProductCatSale: PropTypes.object
};
export default NewOrderOrderDetailForm;
